import { Route, Switch } from 'react-router-dom';
import { FundRequestsTablePage } from './FundRequestsTablePage';
import { SubmitRequest } from './FundRequestDetail/SubmitRequest';
import ExpenseSubmission from './FundRequestDetail';
import DirectDeposit from './DirectDeposit';
import FundRequests from './FundRequests';
import Payees from './Payees';
import PayeeDetails from './Payees/PayeeDetails';
import { FundRequestContextProvider } from '~/context/fundrequests';

export const FundRequestsIndex = () => {
    return (
        <FundRequestContextProvider>
            <Switch>
                <Route exact path='/requests' component={FundRequests} />
                <Route exact path='/payees' component={Payees} />
                <Route
                    exact
                    path='/payees/details/:vendorId'
                    component={PayeeDetails}
                />
                <Route
                    path='/requests/expensesTable'
                    component={FundRequestsTablePage}
                />
                <Route
                    path='/requests/request/submit/:fundrequest_id'
                    component={ExpenseSubmission}
                />
                <Route
                    path='/requests/request/submit'
                    component={ExpenseSubmission}
                />

                <Route
                    path='/requests/direct/deposit'
                    component={DirectDeposit}
                />
                <Route
                    path='/requests/submission/confirmation'
                    component={SubmitRequest}
                />
            </Switch>
        </FundRequestContextProvider>
    );
};
